export default __webpack_public_path__ + "static/media/albedo.868fd258.png";